import { render, staticRenderFns } from "./UserLimited.vue?vue&type=template&id=595104f2&scoped=true"
import script from "./UserLimited.vue?vue&type=script&lang=js"
export * from "./UserLimited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595104f2",
  null
  
)

export default component.exports